import { render } from "./NeuroMedicine.vue?vue&type=template&id=5ce820fb&scoped=true"
import script from "./NeuroMedicine.vue?vue&type=script&lang=ts"
export * from "./NeuroMedicine.vue?vue&type=script&lang=ts"

import "./NeuroMedicine.vue?vue&type=style&index=0&id=5ce820fb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5ce820fb"

export default script